import {useAdminApi} from 'quickstart/hooks/useApi'
import * as R from 'rambdax'
import {AdminType, logger} from 'tizra'
import {makeOptions} from '../utils'

const log = logger('blocks/admin/hooks/useMetaTypeOptions')

interface UseMetaTypeOptionsProps {
  format?: (x: AdminType) => string
}

export const useMetaTypeOptions = ({
  format = x => `${x.displayNamePlural} (${x.name})`,
}: UseMetaTypeOptionsProps = {}) => {
  const metaTypes = R.piped(
    useAdminApi.types().data || {},
    R.values,
    R.filter(
      // Include PdfPage and toc-entry even though they are marked as internal
      // types, because we need to be able to include/exclude these in browse
      // block configs.
      t => t.name === 'PdfPage' || t.name === 'toc-entry' || !t.isInternal,
    ),
    R.map(t =>
      t.name === 'PdfPage' && t.displayName === 'Free stuff' ?
        {
          ...t,
          displayName: 'Page',
          displayNamePlural: 'Pages',
          displayNameSingular: 'Page',
        }
      : t,
    ),
  )
  return makeOptions({valueKey: 'name', labelKey: format})(metaTypes)
}
